'use client'
import dynamic from 'next/dynamic'
const CurrencyConvert = dynamic(() => import('./CurrencyConvert'), {
  ssr: false,
})

export const CurrencyWrapper = () => {
  return <CurrencyConvert />
}
